import { forwardRef } from 'react';

export const FavoritesIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0)">
          <path
            d="M5.96181 5.06807L7.98761 0.502283C7.99115 0.501778 7.99512 0.501465 7.99941 0.501465C8.00369 0.501465 8.00767 0.501778 8.01121 0.502283L10.037 5.06807L10.142 5.30468L10.3958 5.35554L15.4992 6.37817C15.4993 6.37877 15.4993 6.37916 15.4992 6.37948C15.4991 6.37985 15.4991 6.37978 15.4991 6.37979L15.4991 6.37981L11.9385 9.94661L11.7497 10.1357L11.8021 10.3977L12.8206 15.5002L12.8206 15.5002L12.8207 15.5011L12.8205 15.5012L12.8207 15.5014L12.8206 15.5015L8.20276 13.4456L7.9994 13.355L7.79604 13.4456L3.1785 15.5014L3.17811 15.5011L3.1782 15.5002L3.17821 15.5002L4.19676 10.3977L4.24906 10.1357L4.0603 9.94661L0.499746 6.37981L0.499722 6.37979C0.499719 6.37978 0.49971 6.3798 0.499691 6.37977C0.499671 6.37974 0.499639 6.37967 0.499592 6.37948C0.499512 6.37916 0.499463 6.37877 0.499583 6.37817L5.60301 5.35554L5.85682 5.30468L5.96181 5.06807Z"
            stroke="currentColor"
            fill="none"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
